import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=5b362463"
import script from "./Reminder.js?vue&type=script&lang=js&external"
export * from "./Reminder.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports